module.exports = __webpack_public_path__ + "static/media/tracking7.d3e87d28.png";